module.exports = __webpack_public_path__ + "media/images/sales/weddingday/mv-32a6a72281d8c326ebc84278b28b603a.svg";